import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  nftInfo,
} from "../NftMarketPage/contractData";
import { ethers } from "ethers";
import {
  metaspaceNFTMarketplaceAddress,
  metaspaceNFTMarketplaceABI,
} from "../../../config/data";
import NftMarketHomepage from "../NftMarketPage/NftMarketHomepage";
import Loading from "../../../Components/Loader";
import ConfirmPopup from "../../../Components/ConfirmPopup";

import DetailBanner from "./DetailBanner";
import HistoryWrapper from "./HistoryWrapper";
import TabsNftDetails from "./TabsNftDetails";
import environmentVariables from "../../../config/environmentVariables";
import { getEthersProvider } from "../../../utils/rpcProvider";

const Root = styled.div`
  margin-bottom: 50px;
`;
const Container = styled.div``;
const NftMarketContainer = styled.div`
  display: block;
  justify-content: space-between;
  /* position: absolute; */
  width: 100%;
  z-index: 999999;
  padding: 0 5rem 5rem 5rem;
  @media (max-width: 1260px) {
    padding: 0 5.5rem;
    width: 89%;
  }
  @media (max-width: 1100px) {
    z-index: 1;
  }
  @media (max-width: 1024px) {
    padding: 0 2.5rem;
    width: 100%;
  }

  @media (max-width: 430px) {
    padding: 0rem;
    width: 88%;
  }
`;
const DetailContainer = styled.div`
  position: relative;
`;
const PistolTabdetails = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: center;
  align-items: flex-start;
  padding: 0 5rem;
  margin-top: 50px;

  @media (max-width: 768px) {
    padding: 0px;
    margin-top: 4rem;
  }
  @media (max-width: 1024px) {
    padding: 0px;
    margin-top: 4rem;
  }
`;

const TableHistoryContainer = styled.div`
  width: 50%;
  padding-right: 40px;
  z-index: 99;

  @media (max-width: 1024px) {
    width: 100%;
    margin-top: 0;
    padding: 0;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    padding: 0;
  }
`;

const DetailNft = ({ allContractDetails }) => {
  const params = useParams();
  const [detailOfNft, setDetailOfNft] = useState({});
  const [tradeList, setTradeList] = useState({});
  const [bidList, setBidList] = useState({});
  const [showCreatedPopup, setShowCreatedPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [specificData, setSpecificData] = useState();
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [params]);

  const GetTokenDetails = () => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/${params.contract.toLowerCase()}/${
          params.tokenId
        }`
      )
      .then((response) => {
        // console.log("GetTokenDetails", response.data);
        setSpecificData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetTokenDetails();
  }, []);

  const fetchData = async () => {
    if (params?.contract && params?.tokenId) {
      setLoading(true);
      const trade = await fetchTradedData();
      const bid = await fetchBidPlacedData();
      // const [trade, bid] = await Promise.all([fetchTradedData(), fetchBidPlacedData()]);
      // console.log("trade", trade);
      // console.log("bid", bid);
      setLoading(false);
      setBidList(bid);
      setTradeList(trade);
      if (allContractDetails?.metaspaceNFTMarketplaceContract) {
        fetchFeaturedData(params.contract, params.tokenId);
      }
    }
  };

  const fetchTradedData = async () => {
    // const metaspaceNFTMarketplaceContract = await getMetaspaceNFTMarketplaceContract();

    const provider = getEthersProvider() || new ethers.JsonRpcProvider(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const fromBlock = 36767745;

    const contract = new ethers.Contract(
      metaspaceNFTMarketplaceAddress,
      metaspaceNFTMarketplaceABI,
      provider
    );

    const filter = contract.filters.NFTtraded(params.contract, params.tokenId);

    const a = await contract.queryFilter(filter, fromBlock, "latest");

    // console.log("a inside detailNft", a);

    return a;
  };

  const fetchBidPlacedData = async () => {
    // const metaspaceNFTMarketplaceContract = await getMetaspaceNFTMarketplaceContract();

    const fromBlock = 36767745;
    const provider = getEthersProvider() || new ethers.JsonRpcProvider(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );

    const contract = new ethers.Contract(
      metaspaceNFTMarketplaceAddress,
      metaspaceNFTMarketplaceABI,
      provider
    );

    const filter = contract.filters.BidPlaced(params.contract, params.tokenId);

    const a = await contract.queryFilter(filter, fromBlock, "latest");

    // console.log("a inside detailNft", a);

    return a;
  };

  const fetchFeaturedData = async (contract, i) => {
    try {
      let obj = {};
      // const metaspaceBaseApiURL = await getMetaspaceBaseApiURL(allContractDetails?.nftStakingContract)
      const metaspaceBaseApiURL =
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/`;

      if (allContractDetails?.metaspaceNFTMarketplaceContract) {
        await nftInfo(
          allContractDetails?.metaspaceNFTMarketplaceContract,
          contract.toLowerCase(),
          i
        )
          .then(async (nftContractInfo) => {
            // console.log("nftContractInfo", nftContractInfo);
            if (Number(nftContractInfo.listingStage) !== 0) {
              const nftDetail = await fetchNftDetail(
                contract.toLowerCase(),
                i,
                metaspaceBaseApiURL
              );

              obj = {
                ...obj,
                contract,
                fetchDetails: nftDetail,
                data: nftContractInfo,
              };

              // console.log("obj", obj);

              setDetailOfNft({ ...obj });
              setLoading(false);
            }
          })
          .catch((err) => {
            setMessage(err.message || "Something went wrong");
            setShowCreatedPopup(true);
            setLoading(false);
            console.log("err", err);
          });
      } else {
        setMessage("contract id not found");
        setShowCreatedPopup(true);
        setLoading(false);
        console.log("err", err);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        err.error.data.message || err.message || "Something went wrong"
      );
      setShowCreatedPopup(true);
      console.log("err", err);
    }
  };

  const fetchNftDetail = async (address, index, url) => {
    const response = await axios.get(`${url}${address}/${index}`);
    return response.data;
  };

  // console.log("detailOfNft", detailOfNft);

  return (
    <>
      {loading && <Loading />}
      <Root>
        <Container>
          <NftMarketContainer>
            <NftMarketHomepage allContractDetails={allContractDetails} />
          </NftMarketContainer>
          <DetailBanner
            fetchData={fetchData}
            allContractDetails={allContractDetails}
            data={detailOfNft.data}
            image={detailOfNft.fetchDetails?.image || ""}
            name={detailOfNft?.fetchDetails?.name || ""}
            specificData={specificData}
            setSpecificData={setSpecificData}
          />
          <PistolTabdetails>
            {/* <NftNameDetailpage allContractDetails={allContractDetails} fetchDetails={detailOfNft?.fetchDetails || {}} data={detailOfNft.data} /> */}
            <TableHistoryContainer>
              <TabsNftDetails
                data={detailOfNft.data}
                fetchDetails={detailOfNft.fetchDetails || {}}
                specificData={specificData}
                setSpecificData={setSpecificData}
              />
            </TableHistoryContainer>
          </PistolTabdetails>
          <HistoryWrapper
            data={detailOfNft.data}
            tradeList={tradeList}
            bidList={bidList}
          />
        </Container>
        {showCreatedPopup && (
          <ConfirmPopup
            showPopup={showCreatedPopup}
            setShowPopup={setShowCreatedPopup}
            onClickFun={() => {
              setShowCreatedPopup(false);
            }}
            text={message}
          ></ConfirmPopup>
        )}
      </Root>
    </>
  );
};

export default DetailNft;
